import PropTypes from 'prop-types';
import { Box, Container, Stack, IconButton, Typography, Button } from '@mui/material';
import { ArrowBackIosNewOutlined } from '@mui/icons-material';

const TransactionHistoryBanner = ({ onBack }) => {
    return (
        <Box
            sx={{
                background: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)',
                px: { xs: 2, md: 4 },
                pt: 3,
                pb: 9,
                borderRadius: '10px'
            }}
        >
            <Container maxWidth="xl" disableGutters>
                <Stack
                    direction={{ xs: 'column', sm: 'row' }}
                    alignItems={{ xs: 'flex-start', sm: 'center' }}
                    justifyContent="space-between"
                    spacing={2}
                >
                    <Stack direction="row" alignItems="center" spacing={2}>
                        <IconButton
                            onClick={onBack}
                            sx={{
                                color: '#fff',
                                bgcolor: 'rgba(255,255,255,0.15)',
                                '&:hover': { bgcolor: 'rgba(255,255,255,0.25)' }
                            }}
                        >
                            <ArrowBackIosNewOutlined fontSize="small" />
                        </IconButton>
                        <Box>
                            <Typography variant="overline" sx={{ color: 'rgba(255,255,255,0.7)', letterSpacing: '0.12em' }}>
                                HR Dashboard / Credit Limits
                            </Typography>
                            <Typography variant="h3" fontWeight={800} sx={{ color: '#fff', mt: -0.5 }}>
                                Transaction History
                            </Typography>
                            <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.8)', mt: 0.5 }}>
                                Audit logs of all employee credit settlements and repayments
                            </Typography>
                        </Box>
                    </Stack>

                    <Button
                        variant="outlined"
                        onClick={onBack}
                        sx={{
                            color: '#fff',
                            borderColor: 'rgba(255,255,255,0.4)',
                            bgcolor: 'rgba(255,255,255,0.1)',
                            backdropFilter: 'blur(6px)',
                            textTransform: 'none',
                            fontWeight: 600,
                            borderRadius: 2,
                            '&:hover': {
                                bgcolor: 'rgba(255,255,255,0.2)',
                                borderColor: '#fff'
                            }
                        }}
                    >
                        Back to Credit Limits
                    </Button>
                </Stack>
            </Container>
        </Box>
    );
};

TransactionHistoryBanner.propTypes = {
    onBack: PropTypes.func.isRequired
};

export default TransactionHistoryBanner;
